import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '@athena/spark/Heading';
import { useAmplitude } from 'src/lib/amplitude';
import Container from 'src/components/ui/Container';
import styles from './TelehealthErrorPage.module.scss';

const TelehealthErrorPage: React.FC = () => {
  const { ampTrackPageView } = useAmplitude('GeneralError');
  const { t } = useTranslation();

  // TODO double check pagename is correct
  useEffect(() => {
    // The error page name, "GeneralError", defined in workflow/routeMap.ts is related
    // to app-insights alerting (https://bitbucket.athenahealth.com/projects/PX/repos/px-application-insights/browse/scripts/azure/azuredeploy.json#102)
    // changing or removing this requires a change to the app insights alerting code
    ampTrackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className={styles.container}>
      <div className={styles.errorImage} />
      <Heading tabIndex={0} className={styles.heading} tag="h1" variant="page">
        {t('ERROR_PAGE_TITLE')}
      </Heading>
      <div tabIndex={0} className={styles.helpText}>
        {t('ERROR_PAGE_HELP_1')}
        <br role="presentation" />
        <br role="presentation" />
        {t('ERROR_PAGE_HELP_2')}
      </div>
    </Container>
  );
};

export default TelehealthErrorPage;
